<template>
  <div class="app-details">
    <EntityList
      v-bind:endpoint="'api/modules'"
      v-bind:filters="`?app.id=${id}`"
      v-bind:entity="moduleEntity"
      v-bind:editAllowedFields="['name']"
      v-bind:notDisplayedFields="[]"
      v-bind:addLinkToDetails="false"
      v-bind:defaultValues="{app: `/api/apps/${id}`}"
      v-bind:title="`Modules for ${computedAppName}`"/>
  </div>
</template>

<script>
import EntityList from './EntityList/EntityList.vue';
import ModuleEntity from '../store/entity/Module';

export default {
  name: 'users',
  components: { EntityList },
  data() {
    return {
      moduleEntity: ModuleEntity,
      appName: '',
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    computedAppName() {
      return this.appName;
    },
  },
  methods: {
    getAppName() {
      this.$http.get(`api/apps/${this.id}`).then((response) => {
        this.appName = response.data.name;
      });
    },
  },
  created() {
    this.getAppName();
  },
};
</script>

<style scoped>

</style>
